module.exports = __webpack_public_path__ + "img/Polkadot_symbol_color.bf5610e9.svg";